export default {"src":"/_next/static/media/kubernetes.699bec56.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};